import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { AmountCell } from "@/components/cells/amount";

export default function CostMaster() {

  const customSearch = (search) => ({
    _or: [
      { department: { name: { _icontains: search } } },
      { grade: { name: { _icontains: search } } },
    ],
  });

  const columns = [
    {
      id: "department.name",
      header: "Department",
      accessorKey: "department.name",
      sortable: true,
    },
    {
      id: "grade.name",
      header: "Grade",
      accessorKey: "grade.name",
    },
    {
      id: "hourly_cost",
      header: "Hourly cost",
      accessorKey: "hourly_cost",
      cell: AmountCell,
    },
  ];

  const fields = ["id", "department.name", "grade.name", "hourly_cost"];

  return (
    <div className="w-full">
      <HeaderPortal>
        <PermissionControlledInput
          rule={"create:*"}
          collection="cost_master"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Cost Master</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      <div className="flex-1 h-full">
        <List
          title="Cost Master"
          endPoint="cost_master"
          columns={columns}
          meta={{
            fields,
            customSearch,
          }}
          sortBy="department"
          sortOrder="aesc"
          href={(item) => item.id}
        />
      </div>
    </div>
  );
}
